export default __webpack_public_path__ + "static/media/netflix-clone.fe925284.webp";